module.exports = "<p ng-repeat=\"bulletin in $ctrl.data\">\r\n    <a style=\"float:right; margin-left: 8px\" ng-href=\"/bulletin/{{bulletin._id}}\" class=\"btn btn-sm btn-more\"><i class=\"fa fa-arrow-circle-right\"></i> more</a>\r\n    <b>{{bulletin.title}}</b><br/><em ng-bind-html=\"$ctrl.getPreviewText(bulletin.description)\"></em>\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/bulletins-widget/bulletins-widget.component.html
// module id = 595
// module chunks = 0